import { createFileRoute } from "@tanstack/react-router";

import { OfficeInbox } from "@/features/office/inbox";
import { officeInboxSearchSchema } from "@/features/office/inbox/_configs/inbox-search-schema";

export const routeId = "/office/inbox";

export const Route = createFileRoute("/office/inbox")({
  component: OfficeInbox,
  validateSearch: officeInboxSearchSchema,
});
